// extracted by mini-css-extract-plugin
export default {"valePor":"VotoValePor_valePor__etMCY","sala":"VotoValePor_sala__+eP8B","modal":"VotoValePor_modal__+XL--"};